import Vue from 'vue'
import App from '@/App.vue'
import router from '@/routes/router'
import store from '@/store/store'
import appInfo from '@/utils/appInfo'

Vue.prototype.$staticUrl = appInfo.staticPath+process.env.BASE_URL;

Vue.prototype.$isIe11 = window.navigator.userAgent.indexOf("Trident/7.0") > -1;
Vue.config.productionTip = false;


if(process.env.NODE_ENV == 'development'){
    Vue.prototype.$routerBaseURL = process.env.BASE_URL;
}else{
    Vue.prototype.$routerBaseURL = '/classic/update/history/2019/190220_jinkamael';
}
const preloaderGetImg = ()=>{
    if(process.env.NODE_ENV == 'development')return [''];
    let baseURL = process.env.BASE_URL;
    let imgArray = [];
    for (let i=0; i < 90; i++)
    {
        imgArray.push(`${baseURL}img/logo_loop/title_${i}.png`);
    };
    for (let i=1; i <= 8; i++)
    {
        if(i==6){
            imgArray.push(`${baseURL}img/bg_${i}_1.jpg`);
            imgArray.push(`${baseURL}img/bg_${i}_2.jpg`);
        }else{
            imgArray.push(`${baseURL}img/bg_${i}.jpg`);
            if(i!=1) imgArray.push(`${baseURL}img/txt_${i}_tit.png`);
        }


    };
    imgArray.push(`${baseURL}img/txt_1_date.png`);
    imgArray.push(`${baseURL}img/txt_1_txt_1.png`);
    imgArray.push(`${baseURL}img/txt_1_txt_2.png`);
    imgArray.push(`${baseURL}img/obj_2_1.png`);
    imgArray.push(`${baseURL}img/obj_2_2.png`);
    imgArray.push(`${baseURL}img/obj_3_1.png`);
    imgArray.push(`${baseURL}img/obj_3_1_ef.png`);
    imgArray.push(`${baseURL}img/obj_3_2.png`);
    imgArray.push(`${baseURL}img/obj_3_2_ef.png`);
    imgArray.push(`${baseURL}img/obj_4_1.png`);
    imgArray.push(`${baseURL}img/obj_4_1_ef.png`);
    imgArray.push(`${baseURL}img/obj_4_2.png`);
    imgArray.push(`${baseURL}img/obj_4_2_ef.png`);
    imgArray.push(`${baseURL}img/obj_5_1.png`);
    imgArray.push(`${baseURL}img/obj_5_1_w.png`);
    imgArray.push(`${baseURL}img/obj_5_2.png`);
    imgArray.push(`${baseURL}img/obj_5_2_w.png`);
    imgArray.push(`${baseURL}img/obj_5_3.png`);
    imgArray.push(`${baseURL}img/obj_5_3_w.png`);
    imgArray.push(`${baseURL}img/obj_6_1.png`);
    imgArray.push(`${baseURL}img/obj_6_2.png`);

    return imgArray;

}

const preloaderGetVideo = ()=>{
    if(process.env.NODE_ENV == 'development')return [''];
    let baseURL = process.env.BASE_URL;
    let videoArray = [];

    // videoArray.push(`${appInfo.staticPath}${baseURL}img/bg_5.mp4`);
    // videoArray.push(`${appInfo.staticPath}${baseURL}img/bg_7.mp4`);
    // videoArray.push(`${appInfo.staticPath}${baseURL}img/bg_8.mp4`);
    // videoArray.push(`${appInfo.staticPath}${baseURL}img/bg6_1.mp4`);
    return videoArray;
}

new nc.promokit.Preloader({
    'game': 'lineage2',
    'delay': 100,
    image: preloaderGetImg(),
    "video": preloaderGetVideo()
});


$(document).on("preloadend", function (){
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
});

